export function isValidDate(
  date: Date | undefined,
  min: Date | undefined,
  max: Date | undefined
): boolean {
  if (!date) {
    return true;
  }

  let valid = true;

  // Normalize to midnight for date-only comparison
  const normalizedDate = new Date(date);
  normalizedDate.setHours(0, 0, 0, 0);

  if (min) {
    const normalizedMin = new Date(min);
    normalizedMin.setHours(0, 0, 0, 0);
    valid = normalizedDate >= normalizedMin;
  }

  if (max && valid) {
    const normalizedMax = new Date(max);
    normalizedMax.setHours(0, 0, 0, 0);
    valid = normalizedDate <= normalizedMax;
  }

  return valid;
}
